<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="我的配送员" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div class="common-btn btn" slot="right" @click="goAdd">新增</div>
            </mt-header>
        </div>
        <ul class="distributor">
            <li v-for="item in distributor_list" :key="item.o2o_distributor_id" @click="onEdit(item.o2o_distributor_id)">
                <em>{{item.o2o_distributor_name}}</em>
                <i class="iconfont">&#xe650;</i>
            </li>
        </ul>
    </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getDistributorList } from '../../../api/sellerO2o'
export default {
  name: 'Distributor',
  data () {
    return {
      // 配送员列表
      distributor_list: []
    }
  },
  created: function () {
    this.getDistributorList()
  },
  methods: {
    goAdd () {
      this.$router.push({ name: 'SellerO2ODistributorForm', query: { action: 'add' } })
    },
    onEdit (o2o_distributor_id) {
      this.$router.push({ name: 'SellerO2ODistributorForm', query: { o2o_distributor_id: o2o_distributor_id } })
    },
    getDistributorList () {
      getDistributorList().then(res => {
        this.distributor_list = res.result.list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.common-header{
	.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
}
.main-content{background: #fff;padding:0 $pageSpace}
.distributor{}
.distributor li{line-height:1rem;padding:.5rem 1rem;background:#fff;}
.distributor i{float:right}
</style>
